(function () {
    'use strict';

    angular
        .module('statistics')
        .config(StatisticsRoute);

    StatisticsRoute.$inject = ['$stateProvider'];

    /* @ngInject */
    function StatisticsRoute ($stateProvider) {
        $stateProvider
            .state ('root.statistics', {
                url: '/statistics',
                views: {
                    'inner-view@root': {
                        templateUrl: 'templates/statistics/reportFilter.html',
                        controller: 'StatisticsController',
                        controllerAs: 'statisticsCtrl'
                    }
                }
            });
    }
})();